import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';
import { ICONS } from '../../../../_helpers/icons.constants';
import { TextboxComponent } from '../../../../shared/design-system/textbox/textbox.component';
import { TextboxConfig } from '../../../../shared/design-system/textbox/textbox.modal';

interface CalenderConfig {
  searchIcon: string;
}

@Component({
  selector: 'new-formly-calendar-date-input',
  templateUrl: "./new-formly-calendar-date-input.component.html",
  standalone: true,
  imports: [CommonModule, TranslateModule, FormlyModule, ReactiveFormsModule, SharedModule, TextboxComponent]
})
export class NewFormlyCalendarDateInputComponent extends FieldType implements OnInit, OnDestroy, AfterViewInit {
  @Output() dateChange = new EventEmitter<Date>();
  
  @ViewChild("dateInput") dateInput: any;
  public ICONS = ICONS;
  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  isLabelVisible: boolean = false;
  addTopMargin: boolean = false;
  calendarLabel: string = "";
  calendarConfig : CalenderConfig = {
    searchIcon: ICONS.SEARCH
  };
  textboxConfig : TextboxConfig = {
    id: 'dateInput',
    iconSrc: ICONS.CALENDAR,
    iconPosition: 'right',
  };
  dateFormats = [
    {
      id: 1,
      name: "d/m/y"
    },
    {
      id: 2,
      name: "d/m/Y"
    },
    {
      id: 3,
      name: "m/d/d"
    },
    {
      id: 4,
      name: "m/d/Y"
    },
    {
      id: 5,
      name: "y/m/d"
    },
    {
      id: 6,
      name: "Y/M"
    },
    {
      id: 7,
      name: "m-d-y"
    },
    {
      id: 8,
      name: "d-m-y"
    },
    {
      id: 9,
      name: "d-M-y"
    },
    {
      id: 10,
      name: "d-M-Y"
    },
    {
      id: 11,
      name: "d.m.y"
    },
    {
      id: 12,
      name: "d.m.Y"
    },
    {
      id: 13,
      name: "y.m.d"
    },
    {
      id: 14,
      name: "M d, y"
    },
    {
      id: 15,
      name: "M d, Y"
    },
    {
      id: 16,
      name: "dmy"
    },
    {
      id: 17,
      name: "ymd"
    },
    {
      id: 18,
      name: "dmY"
    },
    {
      id: 19,
      name: "Ymd"
    },
  ];
  dateFormatString: string = "d-M-Y";
  datePickerOptions: FlatpickrOptions = {
    mode: "single",
    defaultDate: new Date(),
    altInput: true,
    altFormat: this.dateFormatString,
    dateFormat: this.dateFormatString
  };
  disabled: boolean;
  constructor(private dynamicFormService: DynamicFormService) {
    super();
  }


  ngOnInit() {
    this.datePickerOptions.defaultDate = new Date();
    if (this.field && this.field.formControl && this.field.formControl.value) {
      this.datePickerOptions.defaultDate = new Date(this.field.formControl.value);
    }

    if (this.field && this.field.props) {
      this.calendarLabel = this.field.props.label ? this.field.props.label : '';
      this.isLabelVisible = this.field.props.isLabelVisible;
      this.addTopMargin = this.field.props.addTopMargin;
      if (this.field.props.hideDefaultDate) {
        this.datePickerOptions.defaultDate = this.field.props.hideDefaultDate ? '' : this.datePickerOptions.defaultDate;
      }
    }

    if (this.field && this.field.props && this.field.props.maxDate) {
      this.datePickerOptions.maxDate = new Date(this.field.props.maxDate);
    }

    if (this.field && this.field.props && this.field.props.minDate) {
      this.datePickerOptions.minDate = new Date(this.field.props.minDate);
    }

    if (this.field && this.field.props && this.field.props.dateFormat) {
      this.datePickerOptions.dateFormat = this.field.props.dateFormat;
      this.dateFormatString = this.dateFormats.find(it => it.id == this.field.props.dateFormat).name;
      this.datePickerOptions = {
        mode: "single",
        defaultDate: new Date(),
        altInput: true,
        altFormat: this.dateFormatString,
        dateFormat: this.dateFormatString
      };
    }

    if (this.field && this.field.props && this.field.props.altFormat) {
      this.datePickerOptions.altFormat = this.field.props.altFormat;
    }



    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
    this.textboxConfig = {...this.textboxConfig, label: this.calendarLabel, required: this.field?.templateOptions?.required};
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    //Initialize datePicker
    if (this.dateInput && this.dateInput.inputElement && this.dateInput.inputElement.nativeElement) {
      this.dateInput.inputElement.nativeElement.flatpickr(this.datePickerOptions);
    }
  }

  onValueChange(event: any) {
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }
  }
}
